import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { CommonService } from '../../shared/common.service';
import { param } from 'jquery';

@Injectable({
    providedIn: 'root'
})

export class UserLayoutService {
    environment: any;

    constructor(public commonService: CommonService, private http: HttpClient) { }

    // -------------------------------------------------------| PROFILE PAGE |-------------------------------------------------------

    // User Profile 
    UserProfile(profileData: any) {
        let LoginUserData = localStorage.getItem("myToken");
        let headers = new HttpHeaders({
            'Authorization': `${LoginUserData}`
        })
        return this.http.post(this.commonService.rootData.rootUrl + 'Profile/GetUserDetails', profileData, { headers: headers });
    }

    // User update Data
    updateUserProfile(data: any) {
        let LoginUserData = localStorage.getItem("myToken");
        let headers = new HttpHeaders({
            'Authorization': `${LoginUserData}`
        })
        return this.http.post(this.commonService.rootData.rootUrl + 'Profile/UpdateUserDetails', data, { headers: headers });
    }

    // Get Family Member Details
    FamilyMember(userId: any) {
        const LoginUserData = localStorage.getItem("myToken");
        const headers = new HttpHeaders({
            'Authorization': `${LoginUserData}`
        })
        return this.http.get(this.commonService.rootData.rootUrl + 'TravelerInfo/FamilymemberesList/' + userId, { headers: headers });
    }

    //Edit family Member Details ById 
    GetFamilyMemberById(id: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + `TravelerInfo`, { params: id, headers: headers });
    }

    // Update family member details
    UpdateFamilyMember(updateData: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` });
        return this.http.post(this.commonService.rootData.rootUrl + 'TravelerInfo/UpdateTraveler', updateData, { headers });
    }

    UpdateProfileImage(formData: FormData) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` });
        return this.http.post(this.commonService.rootData.rootUrl + 'Profile/UpdateProfileImage', formData, { headers });
    }

    // -------------------------------------------------------| CONTACT US PAGE |-------------------------------------------------------

    // Add ContactUS
    AddContactUs(addContactUs: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` });
        return this.http.post(this.commonService.rootData.rootUrl + 'Profile/CreateContactUs', addContactUs, { headers });
    }

    faqs() {
        let LoginUserData = localStorage.getItem("myToken");
        let headers = new HttpHeaders({
            'Authorization': `${LoginUserData}`
        })
        return this.http.post(this.commonService.rootData.rootUrl + 'Profile/GetAllFaqs', { headers: headers });
    }

    // -------------------------------------------------------| HOME PAGE |-------------------------------------------------------


    // Home Screen Package
    getHomeScreenPackageData() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetHomeScreenPackage', { headers });
    }

    // Get Most PopularPlaces
    getMostPopolarPlacesData() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Package/getMostPopularPlaces', { headers });
    }

    getTrandingPackageData() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetTrendingPackage', { headers });
    }
    GetFeaturedPackage() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetFeaturedPackage', { headers });
    }
    GetGroupPackage() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetGroupPackage', { headers });
    }
    GetReligionsList() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetReligionsList', { headers });
    }
    // Get Most VisitedPlaces
    getMostVisitedPlacesData() {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Package/getMostVisitedPlaces', { headers });
    }

    getPlaceList() {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetAllPlaces', { headers });
    }

    getVehicleListCustomDropDown() {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/vehiclelist', { headers });
    }

    getExplorationData() {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Exploration_data/GetExplorationData', { headers });
    }

    getTrendingFestivalPackagesList(params) {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetTrendingFestivalSearch', { params: params, headers: headers });
    }

    // Add Custom Package Inquiry
    customPackageInquiry(payload: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/CreateCustomPackageInquiry', payload, { headers });
    }

    // Add Custom flight/hotel/vehicle Inquiry
    customFHVInquiry(payload: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/CustomFHVInquiry', payload, { headers });
    }

    // In userLayoutService
    trendingFestivalInquiry(payload: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` });
        return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/CreateTrendingFestivalInquiry', payload, { headers });
    }

    deleteAccount(userId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` });
        return this.http.post(this.commonService.rootData.rootUrl + 'UserAuthentication/DeleteUser/' + userId, {}, { headers: headers });
    }

    // -------------------------------------------------------| PACKAGES PAGE |-------------------------------------------------------

    // Religious Package Details
    getPackagesDetailsById(getPackageDetails: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/getPackageListByCategoryId', { params: getPackageDetails, headers: headers });
    }

    // all Package Details
    getPackagesDetailsByDaysAndNights(getPackageDetails: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/GetAllPackagesByDuration', { params: getPackageDetails, headers: headers });
    }

    // Religious Package Details
    getPackagesDetailsBySearchTerm(getPackageDetails: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'HomeScreenPackage/Search', { params: getPackageDetails, headers: headers });
    }

    forTokenApiCall() {
        let LoginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
        let headers = new HttpHeaders({
            'Authorization': `Bearer ${LoginUserData.myToken}`
        })
        return this.http.get(this.commonService.rootData.rootUrl + 'adminSide/assignPersonDetailsByEmpId', { headers: headers });
    }

    // -------------------------------------------------------| PACKAGES DETAILS PAGE |-------------------------------------------------------

    // Get Itinerary Data By PlaceId
    getBookingDetailsByBookingId(BookingId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'GetBookingDetailsbybookingId/' + BookingId, { headers: headers });
    }

    // Get Itinerary Data By PlaceId
    getOverviewDataByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Package/GetPackagePlaceDetailsById', { params: PlaceId, headers: headers });
    }

    // Get Itinerary Data By PlaceId
    getItineraryataByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Itinerary/' + PlaceId, { headers: headers });
    }

    // Get Itinerary Data By PlaceId
    getItineraryDataByPlaceIdNew(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Itinerary/GetItinerariesForUser/' + PlaceId, { headers: headers });
    }

    // Get Policy Data By PlaceId
    getPolicyDataByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Policy/' + PlaceId, { headers: headers });
    }

    // Get Vehical Data By VehicalId
    getVehicleDataByVehicleId(VehicleId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Vehicle/' + VehicleId, { headers: headers });
    }

    // Get Hotel Data By HotelId
    getHotelDataByHotelId(HotelId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'hotels/' + HotelId, { headers: headers });
    }

    getHotelWithRoomDataByHotelId(IdsPayload: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'hotels/GetHotelDetailsById', { params: IdsPayload, headers: headers });
    }

    getRoomDataByHotelId(HotelId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetRoomDetailsByHotelId', { params: HotelId, headers: headers });
    }

    // Get Activity Data By PlaceId
    getActivityDataByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'Activities/activities', { params: PlaceId, headers: headers });
    }

    // get city list by placeId
    getCityDataByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'CityList/' + PlaceId, { headers: headers });
    }

    // get available dates for package by place id
    getAvailableDatesByPlaceId(PlaceId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'PlaceDateFormate/' + PlaceId, { headers: headers });
    }

    // Add Temp Activity
    addTempActivityData(addTempActivity: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CreateTempActivity', addTempActivity, { headers });
    }

    // Booking Package
    addBookingPackageData(addBookingPackage: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'GuestBooking', addBookingPackage, { headers });
    }
    addBookingPackageDataTemp(addBookingPackage: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CreateNewBookingWeb', addBookingPackage, { headers });
    }

    updateBookingPackageData(updateBookingPackage: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'updateBooking', updateBookingPackage, { headers });
    }

    // update traveler information by bookingId
    updateTravelerInfoById(updateTravelerPackage: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'TravelerInfo/CreateTravelerInfos', updateTravelerPackage, { headers });
    }

    // Booking details By BookingId
    getBookingDetailsById(bookingId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + "GetGuestBookingDetails/" + bookingId, { headers: headers });
    }

    // Current Booking details By BookingId
    getCurrentBookingDetailsById(bookingId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'CurrentBooking/' + bookingId, { headers: headers });
    }

    // Current Booking Details By UserId
    getCurrentBookingDetailsByUserId(UserId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'CurrentBooking/CurrentBooking', { params: UserId, headers: headers });
    }

    // Past Booking Details By UserId
    getPastBookingDetailsByUserId(UserId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'CurrentBooking/pastbooking', { params: UserId, headers: headers });
    }

    // Get Saved Itinerary
    getSavedItineraryById(UserId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'PackagePlan/ViewSaveItinerary/' + UserId, { headers: headers });
    }

    // Add Feedback 
    addFeedback(addFeedback: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'Feedback/FeedbackProcess', addFeedback, { headers });
    }

    // Get Itinerary Data By PlaceId
    getMedicalHistryByTravelerId(TravelerId: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'MedicalHistory/' + TravelerId, { headers: headers });
    }

    saveMedicalHistoryData(addMedicalHistory: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'MedicalHistory/AddMedical', addMedicalHistory, { headers });
    }

    addShareImages(imagesData: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CurrentBooking/AddImagesCureentAndPastBooking', imagesData, { headers });
    }

    paymentProcess(paymentInfo) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'Payment/PaymentProcess', paymentInfo, { headers });
    }

    bookingStatusUpdate(paymentInfo) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'FinalizeBooking', paymentInfo, { headers });
    }

    standardPackageInquiry(enquiryInfo) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/StandardPackageInquiryStatus', enquiryInfo, { headers });
    }

    updateBookingDetails(enquiryInfo) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'PromoCode/UpdateBookingDetails', enquiryInfo, { headers });
    }

    guestBookingDetails(searchKey: any) {
        const LoginUserData = localStorage.getItem("myToken");
        const headers = new HttpHeaders({
            'Authorization': `${LoginUserData}`
        })
        return this.http.get(this.commonService.rootData.rootUrl + 'GuestCurrentBooking', { headers: headers, params: searchKey });
    }

    paymentIntent(amount: any) {
        return this.http.post(this.commonService.rootData.rootUrl + 'Payment/CreatePaymentIntent', amount);
    }

    getHotelList(placeId: any) {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetAllHotel', { params: placeId, headers });
    }

    getVehicleList(placeId: any) {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'admin/Vehicle/GetAllVehicle', { params: placeId, headers });
    }

    // =====================================================================================================================================================================
    // -----------------------------------------------------------------------| Booking Review Page APIs |------------------------------------------------------------------
    // =====================================================================================================================================================================

    applyPromoCode(promoObj) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'PromoCode/GetPromoDetails', promoObj, { headers });
    }

    getPromoCodes(promoObj) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'admin/PromoCode/GetFilteredPromoCode', { headers, params: promoObj });
    }


    //-------------------- divine Destination -------------------- 
    getCitiesName() {
        return this.http.get(this.commonService.rootData.rootUrl + 'DivineDestinationScreenPackage/GetCitiesName');
    }

    GetPilgrimPathwaysName() {
        return this.http.get(this.commonService.rootData.rootUrl + 'DivineDestinationScreenPackage/GetPilgrimPathwaysName');
    }

    GetDaysFilterList() {
        return this.http.get(this.commonService.rootData.rootUrl + 'DivineDestinationScreenPackage/GetDaysFilterList');
    }

    getDivineDestinationSearch(params: any) {
        return this.http.get(this.commonService.rootData.rootUrl + 'DivineDestinationScreenPackage/GetDivineDestinationSearch', { params: params });
    }

    saveCancellationData(cancellationData: any) {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + `CancelBooking`, cancellationData, { headers });
    }

    getOrganizationAttributesData() {
        const loginUserData = localStorage.getItem('adminToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.get(this.commonService.rootData.rootUrl + 'UserAuthentication/GetOrganizationAttributes', { headers });
    }
    subscribeNew(subscriptionData: any) {
        const loginUserData = localStorage.getItem('myToken');
        const headers = new HttpHeaders({ 'Authorization': `${loginUserData}` })
        return this.http.post(this.commonService.rootData.rootUrl + 'HomeScreenPackage/Subscription', subscriptionData, { headers });
    }
}
